import { defineComponent, computed, resolveComponent, createElementBlock, createBlock, createCommentVNode, openBlock, normalizeClass, renderSlot, resolveDynamicComponent, withCtx, createElementVNode } from 'vue';
import { hasProtocol } from './basler-components.es375.js';

const _hoisted_1 = ["href", "target", "rel"];
const _hoisted_2 = ["href", "onClick", "target", "rel"];
const _hoisted_3 = ["href", "target", "rel"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SuperHyperLink",
  props: {
    uri: {},
    external: { type: Boolean },
    target: {},
    rel: {},
    class: {}
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isEmpty = computed(() => {
      if (typeof props.uri === "object") {
        return false;
      }
      return props.uri === "" || props.uri === void 0;
    });
    const isExternal = computed(() => {
      if (props.external) {
        return true;
      }
      if (props.target && props.target !== "_self") {
        return true;
      }
      if (component.value === "RouterLink") {
        return true;
      }
      if (typeof props.uri === "object") {
        return false;
      }
      const res = props.uri === "" || hasProtocol(props.uri ? props.uri : "", { acceptRelative: true });
      return res;
    });
    const useRel = computed(() => {
      let result = props.rel;
      if (!result && isExternal.value) {
        result = "noopener noreferrer";
      }
      return result;
    });
    const uriAsString = computed(() => {
      if (typeof props.uri === "object") {
        return "";
      }
      return props.uri ? props.uri : "";
    });
    const isStorybook = computed(() => {
      return undefined                               === "true";
    });
    const component = computed(() => {
      if (isStorybook.value) {
        return "a";
      }
      return resolveComponent("RouterLink");
    });
    const emit = __emit;
    const clickHandlerRouter = (event, navigate) => {
      emit("click", event, navigate);
    };
    const clickHandlerNoRouter = (event) => {
      emit("click", event, function() {
      });
    };
    return (_ctx, _cache) => {
      return isEmpty.value ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: normalizeClass(props.class),
        onClick: _cache[0] || (_cache[0] = ($event) => clickHandlerNoRouter($event))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2)) : isStorybook.value ? (openBlock(), createElementBlock("a", {
        key: 1,
        href: uriAsString.value,
        target: _ctx.target,
        rel: useRel.value,
        class: normalizeClass(props.class),
        onClick: _cache[1] || (_cache[1] = ($event) => clickHandlerNoRouter($event))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1)) : !isExternal.value ? (openBlock(), createBlock(resolveDynamicComponent(component.value), {
        key: 2,
        to: _ctx.uri,
        custom: true
      }, {
        default: withCtx(({ href, navigate }) => [
          createElementVNode("a", {
            class: normalizeClass(props.class),
            href,
            onClick: ($event) => clickHandlerRouter($event, navigate),
            target: _ctx.target,
            rel: useRel.value
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 10, _hoisted_2)
        ]),
        _: 3
      }, 8, ["to"])) : isExternal.value ? (openBlock(), createElementBlock("a", {
        key: 3,
        href: uriAsString.value,
        target: _ctx.target,
        rel: useRel.value,
        class: normalizeClass(props.class)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_3)) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
